import { dew as _constantsDew } from "../constants";
import { dew as _yearsDew } from "../../../calculation/years";
import { dew as _patternDew } from "../../../utils/pattern";
import { dew as _AbstractParserWithWordBoundaryDew } from "../../../common/parsers/AbstractParserWithWordBoundary";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const constants_1 = _constantsDew();
  const years_1 = _yearsDew();
  const pattern_1 = _patternDew();
  const constants_2 = _constantsDew();
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const PATTERN = new RegExp(`((?:в)\\s*)?` + `(${pattern_1.matchAnyPattern(constants_1.MONTH_DICTIONARY)})` + `\\s*` + `(?:` + `[,-]?\\s*(${constants_2.YEAR_PATTERN})?` + `)?` + `(?=[^\\s\\w]|\\s+[^0-9]|\\s+$|$)`, constants_1.REGEX_PARTS.flags);
  const MONTH_NAME_GROUP = 2;
  const YEAR_GROUP = 3;
  class RUMonthNameParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    patternLeftBoundary() {
      return constants_1.REGEX_PARTS.leftBoundary;
    }
    innerPattern() {
      return PATTERN;
    }
    innerExtract(context, match) {
      const monthName = match[MONTH_NAME_GROUP].toLowerCase();
      if (match[0].length <= 3 && !constants_1.FULL_MONTH_NAME_DICTIONARY[monthName]) {
        return null;
      }
      const result = context.createParsingResult(match.index, match.index + match[0].length);
      result.start.imply("day", 1);
      const month = constants_1.MONTH_DICTIONARY[monthName];
      result.start.assign("month", month);
      if (match[YEAR_GROUP]) {
        const year = constants_2.parseYear(match[YEAR_GROUP]);
        result.start.assign("year", year);
      } else {
        const year = years_1.findYearClosestToRef(context.refDate, 1, month);
        result.start.imply("year", year);
      }
      return result;
    }
  }
  exports.default = RUMonthNameParser;
  //# sourceMappingURL=RUMonthNameParser.js.map
  return exports;
}